import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {noResultsTemplate, logoTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class SettingsAccountsRestrictedAssetsEdit {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    filterTypeahead('.users-search', 'users', '/' + accountUrl + '/users/search?', 282, 'generic');

    // Set companies and funds bloodhounds
    const companiesBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/companies/search?query=%QUERY',
        wildcard: "%QUERY",
        transform: function(d) { return d.companies; }
      }});
    companiesBloodhound.initialize();

    $('#companies_search').typeahead({
      hint: false,
      highlight: true,
      minLength: 0,
    }, {
      name: 'companies',
      display: 'name',
      limit: 112,
      source: companiesBloodhound.ttAdapter(),
      templates: {
        suggestion(el) {
          if (el.name === null) {
            return noResultsTemplate();
          } else if ((el.logo_url !== null) && (el.logo_url.length > 0)) {
            return logoTemplate(el.name, el.symbol, el.logo_url);
          } else {
            return genericDisplayTemplate(el.name, el.symbol);
          }
        }
      },
    });

    // On selecting a company
    $('#companies_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let companyId = suggestion.value;
      $('#hidden_company_id').val(companyId);
    })

    // On adding a user
    $('.users-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let url = $(location).attr("pathname");
      let params = {};
      let restrictedAssetId = $(this).attr('data-restricted-asset-id');
      params['user_id'] = suggestion.value;
      $.ajax({
        type: "POST",
        dataType: "application/json",
        url: '/' + accountUrl + '/restricted_assets/' + restrictedAssetId + '/restricted_asset_users?' + $.param(params),
        complete(result) {
          Turbo.visit(url);
        }
      });

    })


  }

}